export function findImageThumbnail(primaryVisual, aspect_ratio = 'square') {
  if (!primaryVisual?.thumbnail) return null;
  if (
    primaryVisual.thumbnail.type == 'image/png' &&
    primaryVisual.thumbnail.aspect_ratios.uncropped
  ) {
    return primaryVisual.thumbnail?.aspect_ratios?.uncropped.instances[0].url;
  }

  if (primaryVisual.thumbnail.aspect_ratios[aspect_ratio]?.instances[0].url) {
    return primaryVisual.thumbnail.aspect_ratios[aspect_ratio].instances[0].url;
  }

  return null;
}

/**
 * Map CMS aspect ratio names to CSS aspect-ratio values
 * @param {string} aspectRatio - CMS aspect ratio name (widescreen, normal, square, portrait, thumbnail, uncropped)
 * @param {object} imageData - Optional image data object to calculate aspect ratio for uncropped images
 * @returns {string|null} CSS aspect-ratio value (e.g., "16 / 9") or calculated for uncropped
 */
export function getAspectRatioStyle(aspectRatio, imageData = null) {
  const ratios = {
    widescreen: '16 / 9',
    normal: '4 / 3',
    square: '1 / 1',
    portrait: '8 / 10',
    thumbnail: '4 / 3',
  };

  // For known aspect ratios, return the predefined value
  if (ratios[aspectRatio]) {
    return ratios[aspectRatio];
  }

  // For uncropped images, try to calculate from image dimensions
  if (aspectRatio === 'uncropped' && imageData) {
    try {
      const instances = imageData.aspect_ratios?.uncropped?.instances;
      if (instances && instances.length > 0) {
        // Use the first instance to determine aspect ratio
        const { width, height } = instances[0];
        if (width && height) {
          return `${width} / ${height}`;
        }
      }
    } catch (e) {
      console.warn('Could not calculate aspect ratio for uncropped image:', e);
    }
  }

  // Default to widescreen
  return '16 / 9';
}
